import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { BehaviorSubject, Observable } from 'rxjs';
import { permissionEntity } from '../../constants/permission';
import { userParams } from '../../helpers/helperfunc';
import { automationApi } from '../../constants/automation-api';
import { agentsApi } from '../../constants/agents-api';
import { appMasterApi } from '../../constants/app-master-const';

@Injectable({
    providedIn: 'root',
})
export class AutomationService {

    currentlySelected: BehaviorSubject<any> = new BehaviorSubject(null);
    private readOnlyMode = true;
    submitAutomation(arg0: {
        courseName: any;
        applicationDetails: {
            title: any;
            gender: any;
            dateOfBirth: any;
            forenames: any;
            surname: any;
            address: any;
            streetName: any;
            city: any;
            state: any;
            country: any;
            homePostcode: any;
            homeNumber: any;
            emailAddress: any;
            username: any;
            pswd: any;
            consent: any;
        };
        personalDetails: {
            agentRepresentive: any;
            agentID: any;
            councilorEmail: any;
        };
        educationalDetails: {
            currentEdu: any;
            education: any;
            institution: any;
            institutionCountry: any;
            titleofquali: any;
            finalGrade: any;
            fromMonth: any;
            fromYear: any;
            toMonth: any;
            toYear: any;
            englishFirstLang: any;
            awardingBody: any;
            resultYear: any;
            score: any;
        };
        employmentDetails: { experience: any };
        residentialCategory: {
            financeSupport: any;
            countryofBirth: any;
            permanentDomicile: any;
            DistanceLearning: any;
            ukNational: any;
            passportInformation: string;
            passportNo: string;
            issueDate: string;
            expiryDate: string;
            passName: string;
            passNationality: string;
            passContryBirth: string;
            curentlyUk: string;
            refusedVisa: string;
            filepassport: string;
            ukStudy: string;
            visa: string;
        };
        statementAndReferee: {
            filesop: string;
            sop: string;
            refereeName: string;
            refereeEmail: string;
            refereeconfirmEmail: string;
            refereePosition: string;
            filelor: any;
        };
        research: { pgResearchApplicant: string };
        supplementary: { ethnicity: string; disability: string };
        declaration: { declaration: string };
        applicationId: any;
        intake: string;
        cams_id: string;
    }) {
        throw new Error('Method not implemented.');
    }
    permissions_entity = permissionEntity;

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) { }

    getAutomationModule(pagination: PaginationType): Observable<any> {
        // let query = '?';
        // if (sort) {
        //     query += `sortData=${sort}&`;
        // }
        // query += userParams.call(this, this.permissions_entity.modules.options);
        // query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${automationApi.getAutomationOptions}`
        );
    }

    getUniData(pagination: PaginationType): Observable<any> {
        return this.httpClientService.get(
            `${automationApi.getAutomationOptions}`
        );
    }

    getAutomationById(id: string): Observable<any> {
        return this.httpClientService.get(
            automationApi.getAutomationById.replace(':courseID', id)
        );
    }

    createAutomation(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            automationApi.createAutomation,
            payload
        );
    }

    updateCourseFilter(Id: string, payload: unknown): Observable<any> {
        return this.httpClientService.put(
            automationApi.updateAutomationById.replace(':courseID', Id),
            payload
        );
    }

    getStudentInfoById(id: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.studentDataByID}${id}`
        );
    }
     getliverpoolApplicationType(): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.liverpoolApplicationType}`
        );
    }
     getHeriotwattApplicationType(): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.heriotwattApplicationType}`
        );
    }
    getretellAi(caller_id: any, cams_id: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.getretellAi}caller_id=${caller_id}&applicationId=${cams_id}`
        );
    }
    getgetByIdAdmin(id: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.getAppById}${id}`
        );
    }
    submitAutomationCoventry(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.submitAutomation,
            payload
        );
    }
    SubmitAutomation(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.submitAutomation,
            payload
        );
    }

    submitDataAutomation(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.submitAutomation,
            payload
        );
    }
    getARUGrade(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.aruGrade,

        );
    }
    getDundeeGrade(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.dundeeGrade,

        );
    }
    getlawCourseCategory(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.lawCourseCategory,

        );
    }
    getSubject(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.eaSubject,

        );
    }
    getliverpool_HS_Board(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.liverpool_HS_Board,

        );
    }
    getSouthWalesJobDescription(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.southWalesJobDescription,

        );
    }
    getDundeeSubjectList(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.dundeeSubjectList,

        );
    }

    gethuddersfieldLondonStates(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.huddersfieldLondonState,

        );
    }
    getucbQualificationType(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.ucbQualificationType,

        );
    }
    getkingstonUniversityCourses(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.kingstonUniversityCourses,

        );
    }
    getgreenwichStateCountry(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.greenwichStateCountry,

        );
    }

    getkingstonUniversityGrade(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.kingstonUniversityGrade,

        );
    }
    getUlsterOccupation(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.ulsterOccupation,

        );
    }

    getAutomationCoventry(camsId: any, universityId: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.submitAutomation}?camsId=${camsId}&universityId=${universityId}`
        );
    }
    // add
    // getPdfData(camsId: any, Id: any): Observable<any> {
    //     return this.httpClientService.post(
    //         // `${appMasterApi.pdfData}?camsId=${camsId}&Id=${Id}`


    //     );
    // }
    getPdfData(camsId: any, Id: any): Observable<any> {
        const body = { id: Id , applicationId: camsId };
        return this.httpClientService.post(appMasterApi.pdfData, body);
    }
    getDataAutomation(camsId: any, universityId: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.submitAutomation}?camsId=${camsId}&universityId=${universityId}`
        );
    }
    automationStatus(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.automationStatus,
            payload
        );
    }
    automationStatusAutomationLog(payload: unknown): Observable<any> {
        return this.httpClientService.postCustom(
            appMasterApi.automationStatus,
            payload,
            true, // isBasicAuth
            { username: 'automation', password: 'Indiaa9236' } // custom creds
        );
    }
    automationLogExport(appliedFilter: any = null): any {
        let params = "";
        params += `limit=1999&skip: 0&`;
        const filterObject = Object.keys(appliedFilter)
            .filter(key => appliedFilter[key])  // Remove empty values
            .map(key => `${key}=${appliedFilter[key]}`) // Format key-value pairs
            .join('&'); // Join with '&'
        console.log(filterObject);
        params += filterObject;
        let apiUrl = `https://api-console.crizac.com/v1/api/applicationAutomation/export?${params}`;
        window.open(apiUrl, '_blank');
    }
    automationActivityLogExport(appliedFilter: any = null): any {
        let params = "";
        params += `limit=1999&skip: 0&`;
        const filterObject = Object.keys(appliedFilter)
            .filter(key => appliedFilter[key])  // Remove empty values
            .map(key => `${key}=${appliedFilter[key]}`) // Format key-value pairs
            .join('&'); // Join with '&'
        console.log(filterObject);
        params += filterObject;
        let apiUrl = `https://api-console.crizac.com/v1/api/automationActivityLog/export?${params}`;
        window.open(apiUrl, '_blank');
    }
    automationARUSubject(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.getARUSubjects

        );
    }

    automationARUQualificaiton(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.getARUQualification

        );
    }
    automationBCUQualificaiton(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.getBCUQualification

        );
    }
    automationBCUSubject(): Observable<any> {
        return this.httpClientService.get(
            appMasterApi.getBCUSubject

        );
    }
    get selectedUniversity() {
        return this.selectedUniversity.Observable();
    }

    set selectedUniversity(university) {
        this.selectedUniversity.next(university);
    }


    async getAutomationFormData(data: any, appliedFilter: any = null) {

        let params = "?";
        params += `&limit=${data.limit}&skip=${data.skip}`;
        if (appliedFilter) {
            // Assuming appliedFilter needs to be fetched or processed asynchronously
            const filters = await Promise.all(
                appliedFilter.map(async (item: any) => {
                    const key = Object.keys(item)[0];
                    const value = item[key];
                    return `&${key}=${value}`;
                })
            );

            params += filters.join('');
        }


        return this.httpClientService.get(
            `${appMasterApi.getAutomationApplication}${params}`
        );
    }

    async getAutomationFormData2(data: any, appliedFilter: any = null) {
        let params = "?";
        params += `limit=${data.limit}&skip=${data.skip}&`;
        params += appliedFilter;
        return this.httpClientService.get(
            `${appMasterApi.getAutomationApplication}${params}`
        );
    }

    async getAutomationActivity(data: any, appliedFilter: any = null) {
        let params = "?";
        params += `limit=${data.limit}&skip=${data.skip}&`;
        params += appliedFilter;
        return this.httpClientService.get(
            `${appMasterApi.getAutomationActivity}${params}`
            // `${appMasterApi.getAutomationActivity}`
        );
    }


    getTCDagentForm(id: any, payload: any): Observable<any> {
        return this.httpClientService.postPhpForPDF(`${appMasterApi.getTcdAgentform}${id}`
            , payload)
    }
    setReadOnlyMode(value: boolean): void {
    this.readOnlyMode = value;
    }

    isReadOnly(fieldName: string): boolean {
        return this.readOnlyMode;
    }
}
